export default __webpack_public_path__ + "static/sydney-4041b16cf3a871284405c4c9c67bc71c.png";